import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=30713f23&scoped=true"
import script from "./TextQuestion.vue?vue&type=script&lang=js"
export * from "./TextQuestion.vue?vue&type=script&lang=js"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=30713f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30713f23",
  null
  
)

export default component.exports